module.exports = __webpack_public_path__ + "fonts/NotoSans-Regular.4e291026.woff2";